module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2400.38b4fac6.svg";